import { Box, IconButton, Input, styled } from '@mui/material'

export const Wrapper = styled(Box)`
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.custom.white};

  & .MuiInput-root {
    height: 100%;
  }
`

export const StyledInput = styled(Input)`
  min-width: 0;

  & .MuiInput-input {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.custom.gray2};
    line-height: 100%;
    text-overflow: ellipsis;

    &::placeholder {
      color: ${({ theme }) => theme.palette.custom.gray2};
      opacity: 1;
    }
  }
`

export const IconWrapper = styled(Box)`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;
  color: #1063cd;
`

export const LoaderWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.custom.blue1};
`

export const ClearButton = styled(IconButton)`
  padding: 4px;
  flex-shrink: 0;

  & svg {
    width: 8px;
    height: 8px;
  }
`
